import React from 'react';

export const ProgressRing = ({ size = 36, stroke = 4, progress = 0, color = 'var(--primary)' }) => {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (progress / 100) * circ;
  
  return (
    <svg width={size} height={size} data-testid="progress-ring">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="var(--sky)"
        strokeWidth={stroke}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={stroke}
        fill="none"
        strokeLinecap="round"
        strokeDasharray={`${circ} ${circ}`}
        strokeDashoffset={offset}
        style={{
          transition: 'stroke-dashoffset 420ms cubic-bezier(0.2, 0.7, 0.2, 1)',
          transform: 'rotate(-90deg)',
          transformOrigin: '50% 50%',
        }}
      />
    </svg>
  );
};

export const getProgressStage = (progress) => {
  if (progress >= 80) return { stage: 'Bloom', emoji: '🌸' };
  if (progress >= 50) return { stage: 'Bud', emoji: '🌿' };
  if (progress >= 25) return { stage: 'Sprout', emoji: '🌱' };
  return { stage: 'Seed', emoji: '🌰' };
};